import { generateQuery } from '@/helpers/pathName';
import { useRouter } from 'next/router';
import { GrFormClose } from 'react-icons/gr';
import { PATH_NAME } from '../../configs/pathName';
import LoginGoogleButton from '../buttons/auth/google/LoginGoogleButton';

type Props = {
  isVisible?: boolean | string;
  toggle: Function;
  classname?: string;
};

export const LoginModal = ({ isVisible, toggle, classname }: Props) => {
  const closeModal = () => {
    toggle();
  };
  const router = useRouter();
  return (
    <>
      <div
        className={`${
          isVisible ? 'visible' : 'invisible'
        } fixed bottom-0 left-0 right-0 top-0 z-[300] flex items-center justify-center`}
      >
        <div
          onClick={closeModal}
          className="h-full w-full bg-black opacity-40"
        ></div>
        <div
          className={`${classname} top-2/5 absolute flex max-w-xs items-center justify-center rounded-2xl bg-white`}
        >
          <div className="relative z-10 space-y-5 px-5 py-1.5 text-center text-sm">
            <div
              className="absolute right-3 top-3"
              onClick={() => closeModal()}
            >
              <GrFormClose className=" cursor-pointer text-xl" />
            </div>
            <p className="pt-4">Vui lòng đăng nhập để tiếp tục!</p>
            <LoginGoogleButton size="small" />
            <button
              className="bg-primary__gradient w-full rounded-lg py-2.5 text-sm text-white"
              onClick={() =>
                router.push(PATH_NAME.LOGIN, {
                  query: generateQuery(router),
                })
              }
            >
              Đăng nhập với tài khoản MedX
            </button>
            <p className="py-3">
              Bạn chưa có tài khoản?{' '}
              <span
                className="cursor-pointer text-primary"
                onClick={() =>
                  router.push({
                    pathname: PATH_NAME.REGISTER,
                    query: generateQuery(router),
                  })
                }
              >
                Đăng ký
              </span>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
